exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".set-click[data-v-bc5895b4]{cursor:pointer;text-decoration:underline}", ""]);

// exports
